export const PremiumTier = 'premium'

export type BeehiivUser = {
  id: string
  status: 'validating' | 'invalid' | 'pending' | 'active' | 'inactive' | 'needs_attention'
  subscription_tier: 'free' | typeof PremiumTier
}
